<template>
  <div id="app">
    <el-container class="container egl-container">
      <eiga-head v-show="showSideMenu" :isHeaderShow="showSideMenu" />
      <el-container class="container container-body">
        <side-menu
          :isCollapse="isCollapse"
          ref="sideMenu"
          v-if="showSideMenu"
          @collapseAction="collapseAction"
        ></side-menu>
        <main-container
          v-if="isStoreReady"
          :collapse="isCollapse"
          :class="!isCollapse ? 'menu-ext' : ''"
          :isRouterAlice="isRouterAlice"
        ></main-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import EigaHead from "@/components/common/EigaHead";
import SideMenu from "@/components/common/SideMenu";
import MainContainer from "@/components/common/MainContainer";
import { localStorage } from "@/utils/localStorage";

export default {
  name: "app",
  components: {
    EigaHead,
    SideMenu,
    MainContainer,
  },
  data() {
    return {
      siteSeal: "",
      isCollapse: true,
      isRouterAlice: true,
    };
  },
  computed: {
    ...mapState("app", {
      currentPermission: state => state.currentPermission,
    }),
    ...mapGetters("app", [
      "getModulePermission",
      "allAppStates",
    ]),
    isStoreReady() {
      if (this.$route.path === "/") {
        return true;
      }
      if (this.$route.path === "/login") {
        return true;
      }

      return true;
    },
    showSideMenu() {
      let isDisp = true;
      const excludedArray = ["/", "/login"];
      const { name: rName, path: rPath } = this.$route;

      isDisp = !(rName !== null && excludedArray.includes(rPath));
      return isDisp;
    }
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    ...mapActions("app", [
      "setAppData",
      "setCurrentPermission",
    ]),
    handlePermission(_route) {
      if (this.showSideMenu && _route.matched.length > 0 && _route.matched[0].props) {
        const { module } = _route.matched[0].props.default || {};
        const permissions = this.getModulePermission(module);
        this.setCurrentPermission(permissions);
      }
    },
    collapseAction() {
      this.isCollapse = !this.isCollapse;
    },
    handleUserInfo() {
      if (this.showSideMenu && !this.allAppStates.token && !this.allAppStates.accountId) {
        /* console.log("set vuex again!") */
        const existLocalData = {
          token: localStorage.get("token"),
          userName: localStorage.get("userName"),
          cinemas: localStorage.get("cinemas"),
          brandId: localStorage.get("brandId"),
          accountId: localStorage.get("accountId"),
          cinemaId: localStorage.get("cinemaId"),
          moduleMap: localStorage.get("moduleMap"),
          permissionMap: localStorage.get("permissionMap"),
          currentPermission: localStorage.get("currentPermission"),
          adminType: localStorage.get("adminType"),
          isAdmin: localStorage.get("isAdmin"),
          round: localStorage.get("round"),
          brandCode: localStorage.get("brandCode"),
          dictionary: localStorage.get("dictionary"),
          cinemaObj: localStorage.get("cinemaObj"),
          accountDetailInfo: localStorage.get("accountDetailInfo"),
          loginAsAccountId:  localStorage.get("loginAsAccountId"),
        };

        this.setAppData({ data: existLocalData, vuexOnly: true });
      }
    },
    reload() {
      const that = this;
      this.isRouterAlice = false;
      this.$nextTick(function() {
        that.isRouterAlice = true;
      });
    },
  },
  created() {
    this.$moment.locale(process.env.VUE_APP_LANG || "ja");
  },
  mounted() {
    this.handlePermission(this.$route);
  },
  watch: {
    $route(to) {
      this.handlePermission(to);
      this.handleUserInfo();
    }
  }
};
</script>
